<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.jobinformation_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   size="small"
                   icon="el-icon-edit"
                   v-if="permission.jobinformation_edit&&(scope.row.status == 1||scope.row.status == 2)"
                   @click="$refs.crud.rowEdit(scope.row)">编 辑
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-view"
                   v-if="permission.jobinformation_view"
                   @click="seeDetailHandle(scope.row)">查 看
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-view"
                   v-show="scope.row.status == 1"
                   @click="auditing(scope.row)">提交审核
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="工作信息详情"
               fullscreen
               append-to-body
               width="80%"
               :visible.sync="infoDetailVisible">
      <see :info="detail"></see>
    </el-dialog>
  </basic-container>
</template>
<script>
import { getMyList, getDetail, add, update, remove } from "@/api/job/jobinformation";
import { mapGetters } from "vuex";
import see from './see.vue'
export default {
  data () {
    return {
      infoDetailVisible: false,
      detail: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: false,
        selection: true,
        editBtn: false,
        dialogClickModal: false,
        column: [

          {
            label: "标题",
            prop: "title",
            search: true,
            rules: [{
              required: true,
              message: "请输入标题",
              trigger: "blur"
            }]
          },
          {
            label: "信息类型",
            prop: "type",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dataType: 'number',
            dicQuery: {
              code: 'support_type'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请输入信息类型",
              trigger: "blur"
            }]
          },
          {
            label: "审核状态",
            prop: "status",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dataType: 'number',
            dicQuery: {
              code: 'audit_status'
            },
            disabled: true,
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "优先级",
            prop: "priority",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dataType: 'number',
            dicQuery: {
              code: 'priority'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请输入优先级0低1中2高",
              trigger: "blur"
            }]
          },
          {
            label: "发布机构",
            prop: "createDept",
            type: "select",
            dicUrl: "/api/blade-order/order/getDeptList",
            props: {
              label: "deptName",
              value: "id"
            },
            display: false,
            hide: true,
            search: true,
          },
          {
            label: "缩略图",
            prop: "digest",
            bind: 'digest',
            type: 'upload',
            listType: 'picture-img',
            loadText: '图片上传中，请稍等',
            tip: '只能上传jpg/png图片，且不超过500kb',
            // formslot: true,
            action: '/api/blade-resource/oss/endpoint/put-file-attach',
            propsHttp: {
                res: 'data',
                url: 'link'
            },
            rules: [{
              required: false,
              message: "请上传缩略图",
              trigger: "blur"
            }],
            span: 24,
            row: true,
            search: false
          },
          {
            label: "发布人",
            prop: "createUser",
            type: 'select',
            dicUrl: "/api/blade-order/order/getPublishUserList",
            props: {
              label: "userName",
              value: "userId"
            },
            hide: true,
            display: false,
            search: true
            // display:false
          },
          {
            label: "内容",
            prop: "content",
            component: 'AvueUeditor',
            options: {
              action: '/api/blade-resource/oss/endpoint/put-file',
              props: {
                res: "data",
                url: "link",
              }
            },
            hide: true,
            minRows: 6,
            span: 24,
            rules: [{
              required: true,
              message: "请输入内容",
              trigger: "blur"
            }]
          },
          {
            label: '拒绝原因',
            prop: 'remark',
            row: true,
            display: false,
            disabled: true,
            hide: true,
            span: 24,
            type: "textarea",
            rules: [{
              required: true,
              message: "请填写原因",
              trigger: "click"
            }],
          },
          {
            label: "发布时间",
            prop: "createTime",
            type: 'date',
            hide: true,
            display: false,
            search: true,
          },
        ]
      },
      data: []
    };
  },
  components: {
    see
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.jobinformation_add, false),
        viewBtn: this.vaildData(this.permission.jobinformation_view, false),
        delBtn: this.vaildData(this.permission.jobinformation_delete, false),
        editBtn: this.vaildData(this.permission.jobinformation_edit, false)
      };
    },
    ids () {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    auditing(row){
      this.$confirm('是否提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = 0
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }, error => {
          console.log(error);
        });
      }).catch(() => {
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }, error => {
          // loading();
          console.log(error);
        });
      });
    },
    rowSave (row, done, loading) {
      this.$confirm('是否保存到草稿箱?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = 1
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          window.console.log(error);
        });
      }).catch(() => {
        row.status = 0
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          // loading();
          window.console.log(error);
        });
      });

    },
    rowUpdate (row, index, done, loading) {
      this.$confirm('是否保存到草稿箱?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = 1
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          console.log(error);
        });
      }).catch(() => {
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          // loading();
          console.log(error);
        });
      });


    },
    rowDel (row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen (done, type) {
      let column = this.findObject(this.option.column, "remark")
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.status == 2) {
            column.display = true
          } else {
            column.display = false
          }
        });

      }
      done();
    },
    searchReset () {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange (params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange (list) {
      this.selectionList = list;
    },
    selectionClear () {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange (currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange () {
      this.onLoad(this.page, this.query);
    },
    onLoad (page, params = {}) {
      this.loading = true;
      getMyList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    seeDetailHandle (row) {
      this.detail = row;
      this.infoDetailVisible = true
    }
  }
};

</script>
<style>
</style>
